import React, { useState } from 'react';
import './App.css';
import LoginModal from './components/LoginModal';
import RagView from './RagView';
import archDiagram from './ArchDigram.png';
import ContactModal from './components/ContactModel';
import { 
  faFacebook, 
  faLinkedin, 
  faInstagram 
} from '@fortawesome/free-brands-svg-icons';
import {
  faUserShield,
  faFileContract
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type ViewMode = 'landing' | 'rag' | 'architecture' | 'privacy' | 'terms';
type LoginSource = 'textToSql' | 'application' | null;

function App() {
  const [mode, setMode] = useState<ViewMode>('landing');
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [loginSource, setLoginSource] = useState<LoginSource>(null);

  const handleGoToContact = () => setShowContactModal(true);
  const handleContactSuccess = () => setShowContactModal(false);

  const handleGoToLogin = () => {
    setLoginSource('application');
    setShowLoginModal(true);
  };

  const handleGoToArchitecture = () => {
    setMode('architecture');
  };

  const handleWatchDemo = () => {
    setLoginSource('textToSql');
    setShowLoginModal(true);
  };

  const handleLoginSuccess = () => {
    setShowLoginModal(false);

    if (loginSource === 'textToSql') {
      window.location.href = 'https://forgerag.com/dashboard/';
      return;
    }

    setMode('rag');
  };

  const handleLogout = () => {
    setMode('landing');
  };

  if (mode === 'landing') {
    return (
      <>
        <div className="landing">
          <div className="card-grid">
            <a
              onClick={(e) => {
                e.preventDefault();
                handleGoToArchitecture();
              }}
              className="card block no-underline text-inherit cursor-pointer hover:shadow-lg transition-shadow"
            >
              <h2>Architecture View</h2>
            </a>

            <a
              onClick={(e) => {
                e.preventDefault();
                handleGoToLogin();
              }}
              className="card block no-underline text-inherit cursor-pointer hover:shadow-lg transition-shadow"
            >
              <h2>Login to Application</h2>
            </a>

            <a
              onClick={(e) => {
                e.preventDefault();
                handleWatchDemo();
              }}
              className="card block bg-white no-underline text-inherit cursor-pointer hover:shadow-lg transition-shadow duration-300"
            >
              <h2>Text to SQL</h2>
            </a>
          </div>

          <div className="Heading">
            <h1>ENTERPRISE - RAG - PLATFORM</h1>
            <div className="ContactUs flex gap-4">
              <a
                onClick={(e) => {
                  e.preventDefault();
                  handleGoToContact();
                }}
                className="no-underline text-inherit cursor-pointer hover:shadow-lg transition-shadow"
              >
                <span className="contact-us-btn">Contact US</span>
              </a>
              <span> | Social </span>

              <a
                href="https://www.facebook.com/profile.php?id=61586574128434"
                className="social-icon"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  icon={faFacebook}
                  style={{ color: 'hsla(230, 24%, 90%, 1.00)', fontSize: '20px' }}
                />
              </a>

              <a
                href="https://www.instagram.com/enterpriseragplatform/"
                className="social-icon"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  icon={faInstagram}
                  style={{ color: '#E4405F', fontSize: '20px' }}
                />
              </a>

              <a
                href="https://www.linkedin.com/in/indrajit-singh-243a7b85/"
                className="social-icon"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  icon={faLinkedin}
                  style={{ color: '#77b2edff', fontSize: '20px' }}
                />
              </a>

              <a
                onClick={(e) => {
                  e.preventDefault();
                  setMode('privacy');
                }}
                className="social-icon"
                title="Privacy Policy"
              >
                <FontAwesomeIcon icon={faUserShield}   style={{ color: '#ecf0f4ff', fontSize: '20px' }}/>
              </a>

              <a
                onClick={(e) => {
                  e.preventDefault();
                  setMode('terms');
                }}
                className="social-icon"
                title="Terms & Conditions"
              >
                <FontAwesomeIcon icon={faFileContract}   style={{ color: '#f0f2f6ff', fontSize: '20px' }}/>
              </a>
            </div>
          </div>
        </div>

        {showLoginModal && (
          <LoginModal
            onClose={() => setShowLoginModal(false)}
            onSuccess={handleLoginSuccess}
          />
        )}

        {showContactModal && (
          <ContactModal
            onClose={() => setShowContactModal(false)}
            onSuccess={handleContactSuccess}
          />
        )}
      </>
    );
  }

  if (mode === 'architecture') {
    return (
      <div className="architecture-page">
        <button className="back-btn" onClick={() => setMode('landing')}>
          ← Back
        </button>
        <h1 className="h1Arch">Enterprise - Rag - Platform Architecture</h1>
        <img
          src={archDiagram}
          className="architecture-image"
          alt="Architecture Diagram"
        />
        <p className="architecture-text"></p>
      </div>
    );
  }

  if (mode === 'privacy') {
    return (
      <div className="info-page">
        <button className="back-btn" onClick={() => setMode('landing')}>
          ← Back
        </button>
        <h1 className="info-title">Privacy Policy</h1>
        <div className="info-content">
          <p>
            <strong>Who We Are:</strong> ForgeRag is an enterprise AI platform focused on
            RAG and Text-to-SQL solutions.
          </p>
          <p>
            <strong>Personal Data We Collect:</strong> We may collect names, email
            addresses, account information, usage data, and schemas submitted through
            the platform.
          </p>
          <p>
            <strong>How and Why We Use Data:</strong> We use data to operate the
            platform, improve AI performance, provide support, and analyze usage.
          </p>
          <p>
            <strong>Lawful Basis:</strong> Where applicable, we process data based on
            consent, legitimate interest, contractual necessity, and legal obligations.
          </p>
          <p>
            <strong>Third Parties:</strong> We may use providers such as Azure, Qdrant,
            PostgreSQL infrastructure, analytics providers, and payment processors.
          </p>
          <p>
            <strong>Data Retention:</strong> Data is retained only as long as necessary
            for service delivery, legal compliance, and business operations.
          </p>
          <p>
            <strong>International Transfers:</strong> Data may be processed across
            multiple regions depending on infrastructure and customer location.
          </p>
          <p>
            <strong>User Rights:</strong> Users may request access, correction, deletion,
            or export of their data, subject to applicable law.
          </p>
          <p>
            <strong>AI Usage Disclosure:</strong> ForgeRag uses AI for schema
            understanding, retrieval, and Text-to-SQL generation.
          </p>
          <p>
            <strong>Security Measures:</strong> We use reasonable security measures
            including access controls, secure infrastructure, and data protection
            practices.
          </p>
        </div>
      </div>
    );
  }

  if (mode === 'terms') {
    return (
      <div className="info-page">
        <button className="back-btn" onClick={() => setMode('landing')}>
          ← Back
        </button>
        <h1 className="info-title">Terms and Conditions</h1>
        <div className="info-content">
          <p>By using ForgeRag, you agree to these Terms and Conditions.</p>
          <p>
            ForgeRag provides enterprise AI features including RAG workflows and
            Text-to-SQL capabilities.
          </p>
          <p>
            Users are responsible for providing lawful content and for reviewing
            AI-generated outputs before business use.
          </p>
          <p>
            All platform code, branding, and product functionality remain the
            intellectual property of ForgeRag unless otherwise stated.
          </p>
          <p>
            Users may not misuse the service, attempt unauthorized access, reverse
            engineer restricted features, or use the platform for unlawful activity.
          </p>
          <p>
            ForgeRag may update, suspend, or modify parts of the service at any time.
          </p>
          <p>
            To the maximum extent permitted by law, ForgeRag is not liable for
            indirect, incidental, or consequential damages arising from use of the
            platform.
          </p>
          <p>
            These terms may be updated from time to time, and continued use of the
            platform constitutes acceptance of the updated terms.
          </p>
        </div>
      </div>
    );
  }

  if (mode === 'rag') {
    return <RagView onLogout={handleLogout} />;
  }

  return null;
}

export default App;

